import AdCard from './ad-card'

export default function AdCardWrapper({ ad, placement, index }) {
  if (!ad) {
    return null
  }

  return (
    <div className="h-full w-full">
      <AdCard ad={ad} placement={placement} />
    </div>
  )
}
